import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { APIList } from 'src/interfaces'
import { Entities } from 'src/enums'
import { Gateway } from 'src/api'
import { useApiInstance } from './useApiInstance'
import { buildRequestParams, ObjectType, transformPage, transformPerPage } from './helpers'

interface RequestParams {
  params?: Partial<AdminGatewaysGetParams>
  paramsTransform?: Array<(params: Record<string, any>) => Record<string, any>>
  options?: Omit<UseQueryOptions<unknown, Error, APIList<Gateway>>, 'queryKey' | 'queryFn'>
}

interface AdminGatewaysGetParams {
  limit: number
  offset: number
  sort: string
  projectId: number
  contractorId: number
  stateId: number
}

const schema: ObjectType['schema'] = {
  limit: 'number',
  offset: 'number',
  sort: 'string',
  projectId: 'number',
  contractorId: 'number',
  stateId: 'number'
}

export const useGatewaysListRequest = ({ params = {}, paramsTransform = [], options }: RequestParams = {}) => {
  const api = useApiInstance()

  const transformedParams = [transformPerPage, transformPage, ...paramsTransform].reduce((param, transform) => transform(param), params)
  const queryParams = buildRequestParams<AdminGatewaysGetParams>(transformedParams, schema)
  return useQuery<unknown, Error, APIList<Gateway>>(
    [Entities.Gateway, JSON.stringify(params)],
    async () => {
      const { limit, offset, sort, projectId, contractorId, stateId } = queryParams
      const { data } = await api.v1AdminGatewaysGet(limit, offset, sort, projectId, contractorId, stateId)
      return data || { rows: [], count: 0 }
    },
    {
      enabled: Object.keys(transformedParams).length > 0,
      ...options
    }
  )
}
